import styled from 'styled-components'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    padding: 1rem;
`

export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;

    & input {
        height: 1rem !important;
    }
`
